/* eslint-disable */
import { flushSync } from "react-dom";
import { createRoot } from "react-dom/client";
import uPlot from "uplot";

import SignalDot from "../SignalDot";

export const drawSignalPlugin = (): uPlot.Plugin => {
  const xOffset = 12 * (window?.devicePixelRatio ?? 1);
  const yOffset = 36 * (window?.devicePixelRatio ?? 1);
  const width = 25 * (window?.devicePixelRatio ?? 1);
  const height = 42 * (window?.devicePixelRatio ?? 1);

  const drawSignal = (ctx: any, cx: any, cy: any, signal: number) => {
    const img = new Image();
    img.onload = function () {
      ctx.drawImage(img, cx - xOffset, cy - yOffset, width, height);
    };

    /**
     * Note: To convert the component to HTML in the client side,
     * we need to use flushSync to render the component synchronously
     * instead of using `renderToString` or `renderToStaticMarkup` from react-dom/server.
     *
     * Reference:
     * https://react.dev/reference/react-dom/server/renderToString#removing-rendertostring-from-the-client-code
     */
    const div = document.createElement("div");
    const root = createRoot(div);
    flushSync(() => {
      root.render(<SignalDot signal={signal} />);
    });
    img.src = `data:image/svg+xml;base64,${window?.btoa(div.innerHTML)}`;
  };

  function drawPointsAsSignals(u: any, i: any, i0: any, i1: any) {
    const { ctx } = u;
    const { _stroke, scale } = u.series[i];

    ctx.save();
    ctx.fillStyle = _stroke;
    let j = i0;

    while (j <= i1) {
      const val = u.data[i][j];
      const signal = u.data[2][j];

      if (signal === 0) {
        j++;
        continue;
      }

      const cx = Math.round(u.valToPos(u.data[0][j], "x", true));
      const cy = Math.round(u.valToPos(val, scale, true));

      drawSignal(ctx, cx, cy, signal);
      ctx.fill();
      j++;
    }

    ctx.restore();
  }

  return {
    hooks: {},
    opts: (_u: any, opts: any) => {
      opts.series.forEach((s: any, i: any) => {
        if (i > 0) {
          uPlot.assign(s, {
            points: {
              show: drawPointsAsSignals,
            },
          });
        }
      });
    },
  };
};
